import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import * as Constants from "../../../../constants/Constants";
import "./ApproveDenyRenderer.css";

const SendEmailRenderer = (props) => {
  const sendEmailChange = () => {
    props.sendEmaiDetail(props.data);
  };

  return (
    <>
      <Button
        id="approveDenyButton"
        className="button-primary-md sendEmailButton"
        onClick={() => sendEmailChange()}
      >
        {Constants.SEND_EMAIL}
      </Button>
    </>
  );
};

export default SendEmailRenderer;
